module.exports = __webpack_public_path__ + "static/media/honor_clubs.27699599.png";